import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 120px 28px 32px;

  @media (max-width: 600px) { padding: 80px 22px 24px; }
`;

const Name = styled.h1`
  font-family: 'EB Garamond', Georgia, serif;
  font-size: clamp(2.6rem, 6.5vw, 3.6rem);
  font-weight: 500;
  letter-spacing: -0.02em;
  line-height: 1.05;
  margin: 0 0 14px;
  color: var(--ink);
`;

const Role = styled.p`
  font-style: italic;
  font-size: 1.15rem;
  color: var(--ink-soft);
  margin: 0 0 28px;
  line-height: 1.5;
`;

const Socials = styled.div`
  display: flex;
  gap: 14px 24px;
  flex-wrap: wrap;
  font-size: 1rem;

  a {
    color: var(--ink-soft);
    text-decoration: none;
    border-bottom: 1px solid var(--rule);
    padding: 6px 0 2px;
    transition: color .2s, border-color .2s;
  }
  a:hover {
    color: var(--accent);
    border-color: var(--accent);
    text-decoration: none;
  }
`;

function Hero() {
  return (
    <Section>
      <Name>Ali Hamza.</Name>
      <Role>Software engineer, New York. Finishing a master's at NYU on machine learning for self-driving cars.</Role>
      <Socials>
        <a href="mailto:alihamza19999@gmail.com">email</a>
        <a href="https://github.com/hurryingauto3" target="_blank" rel="noopener noreferrer">github</a>
        <a href="https://www.linkedin.com/in/alihamza99/" target="_blank" rel="noopener noreferrer">linkedin</a>
        <a href="https://x.com/HurryingAuto3" target="_blank" rel="noopener noreferrer">twitter</a>
        <a href="https://www.reddit.com/user/hurryingauto3" target="_blank" rel="noopener noreferrer">reddit</a>
        <a href="https://letterboxd.com/hurryingauto3/" target="_blank" rel="noopener noreferrer">letterboxd</a>
      </Socials>
    </Section>
  );
}

export default Hero;
